import { Box, CircularProgress, Stack, Typography } from '@mui/material'
import React from 'react'
import { Helmet } from 'react-helmet'
import { Outlet } from 'react-router'

import Content from 'components/common/Content'
import Icon from 'components/Icon'
import { Header } from 'components/navigation/Header'
import { useSettingsQueryContext } from 'components/rbac-settings/SettingsQueryContext'

/**
 * Provides the base template with the page Helmet & Header elements for the Account Profile page.
 * Renders a loading indicator while the profile data is being fetched.
 */
export const ProfileIndexRoutesWrapper = () => {
  const { queryCompanyResult } = useSettingsQueryContext()
  const { isFetching } = queryCompanyResult

  return (
    <>
      <Helmet title="Account Settings" />
      <Header>
        <Stack alignItems="center" direction="row" spacing={1}>
          <Icon icon="user" />
          <Typography>Account Settings</Typography>
        </Stack>
      </Header>
      <Content id="Profile">
        {isFetching ? (
          <Box sx={{ height: '100%', width: '100%' }}>
            <Stack
              alignItems="center"
              direction="column"
              justifyContent="center"
              sx={{ height: '100%', width: '100%' }}
            >
              <CircularProgress size={32} thickness={1} />
            </Stack>
          </Box>
        ) : (
          <Outlet />
        )}
      </Content>
    </>
  )
}
